import * as nodeUtils from "../../abstract/controller/utils/nodeUtils";
import DefaultTooltip from "../ui/tooltips/DefaultTooltip";
import ElementTooltipValue from "./ElementTooltipValue";

const _limit = 20;

function TooltipValue({ node, handle, isHidden }) {
  if (isHidden) {
    return null;
  }

  const _value = nodeUtils.getValue(node);

  if (!_value) {
    return null;
  }

  if (_value.length < _limit) {
    return null;
  }

  return (
    <DefaultTooltip handle={handle}>
      <ElementTooltipValue node={node} />
    </DefaultTooltip>
  );
}

export default TooltipValue;
